import { gql } from '@apollo/client';

export const FETCH_REPORT_SCHEDULES = gql`
    query fetchReportSchedules($reportDefinitionId: Guid!) {
        facility {
            id
            reportDefinition(id: $reportDefinitionId) {
                schedules {
                    id
                    alias
                    cron {
                        description
                    }
                    emailSubject
                    activeFromTime
                    activeToTime
                    useFacilityTime
                }
            }
        }
    }
`;
